<template>
  <div class="layout">
    <nav-part></nav-part>
    <router-view :key="$route.fullPath"></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import navPart from '../navPart/index.vue'
import Footer from '../footer/index.vue'
export default {
  components: {
    navPart,
    Footer
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/layout/index.vue